module.exports = __webpack_public_path__ + "static/media/hero-image.6a5fa6a0.webp";